const router = [
  {
    path: '/electron/sign',
    name: 'ElectronSign',
    component: () => import('@/views/sign/ElectronSign.vue'),
    meta: {
      title: '电子签署',
      checkToken: false
    }
  }
];
export default router;
